<template>
    <div class="UserClub">
        <div class="title">
            <strong>{{titleName}}</strong>
            <span class="exit" v-on:click="close">X</span>
        </div>
        <div class="clubInfo">
            <dl class="tab_nav tab_club_w">
                <dd><a class="btn_t tab_light">Layer Data Set</a></dd>
		    </dl>
            <div class="btn_d tab_box cf2 tab_box_w">
                <div class="l_7" style="height: 98%;">
                    <div class="list_box blue_link blue_text data_box scollbarY border_d" >
                        <ul id="lineSel_layer" class="line_list">
                            <li v-for="(item, index) in userData.userInfo.layerData" v-bind:key="index" v-bind:class="{ active: allLayerStatus[item.name] }">
                                <div v-if="item.type!=='!AirPackage'">
                                    <span class="r">
                                        <span class="sel_box_r" v-on:click="toggleLayerStatus(item.name)">
                                            <!--<input id="a_p001" name="placemarkplacemark" data-value="p001" type="checkbox">-->
                                                <label for="a_p001"></label>
                                        </span>
                                    </span>
                                    <div class="r_cell t_l round_s_b">
                                        <div class="td_1 l box_size hide1">
                                            <span class="s_arrow" v-bind:class="{ e_3: item.type==='AirPackage', e_2: item.type==='3dtile',e_1: item.type==='czml', e_5: item.type==='fly' }"></span>{{item.name}}
                                        </div>
                                        <div class="td_4 l box_size hide1">{{item.updated_at}}</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="l_d_btn btn_layer cf2">
                        <!--<span class="l box_size w_2_5">
                            <input type="button" class="round_s fill_btn_r blue_btn_b" v-on:click="isShowCreateLayer=!isShowCreateLayer" value="NEW">
                        </span>-->
                        <span class="l box_size w_2_5">
                            <input type="button" class="round_s fill_btn_r red_btn" v-on:click="removeLayers()" value="DELETE">
                        </span>
                        <span class="r box_size w_2_5">
                            <input type="button" class="round_s fill_btn_r blue_btn_b" v-on:click="switchCreateDemoPlane()" value="Create Demo">
                        </span>
                    </div>
                </div>
                <div class="right_data_box" v-show="isShowCreateLayer" style="height: 100%;">
                    <div class="gray_border round_s scollbarY">
                        <h4 class="th_line_w btn_t"><span class="o_arrow m_1"></span><a>New Layer Information</a></h4>
                        <ul class="r_list">
                            <input class="fill_text box_size round_s" type="text" placeholder="Input Layer Name" v-model="layerInfoTemp.name">
                        </ul>
                        <ul class="r_list" v-show="layerInfoTemp.type === '3dtile'">
                            <input class="fill_text box_size round_s" type="text" placeholder="Input Layer Address" v-model="layerInfoTemp.address">
                        </ul>
                        <ul class="r_list">
                            <div id="newLayerType" class="select box_size round_s select_box" style="width:100%;margin-left:auto;margin-right:auto;">
                                <p>Select Layer Type</p>
                                <ul>
                                    <li data-value="" class="selected">Select Layer Type</li>
                                    <li data-value="3dtile">3DTiles</li>
                                    <!--<li data-value="placemark">PlaceMark</li>-->
                                </ul>
                            </div>
                        </ul>
                    </div>
                    <div class="r_d_btn btn_layer cf2"> 
                        <span class="l w_5">
                            <input type="button" class="round_s fill_btn_r blue_btn_b" value="SAVE" v-on:click="cleateNewLayer()">
                        </span> 
                        <span class="r w_5">
                            <input type="button" class="round_s fill_btn_r gray_btn_g" value="CANCEL" v-on:click="isShowCreateLayer=!isShowCreateLayer">
                        </span> 
                    </div>
                </div>
                <div class="right_data_box" v-show="isShowCreateDemoPackage" style="height: 100%;">
                    <div class="gray_border round_s scollbarY">
                        <h4 class="th_line_w btn_t"><span class="o_arrow m_1"></span><a>New Demo Package</a></h4>
                        <ul class="r_list">
                            <input class="fill_text box_size round_s" type="text" placeholder="Input Demo Name" v-model="demoPackageInfo.name">
                        </ul>
                        <ul v-for="(item, index) in demoPackageInfo.dataList" v-bind:key="index" class="r_list">
                            <input class="fill_text box_size round_s" type="text" v-model="demoPackageInfo.dataList[index]" disabled>
                        </ul>
                    </div>
                    <div class="r_d_btn btn_layer cf2">
                        <span class="l w_5">
                            <input type="button" class="round_s fill_btn_r blue_btn_b" value="SAVE" v-on:click="cleateDemoPackage()">
                        </span> 
                        <span class="r w_5">
                            <input type="button" class="round_s fill_btn_r gray_btn_g" value="CANCEL" v-on:click="isShowCreateDemoPackage=!isShowCreateDemoPackage">
                        </span> 
                    </div>
                </div>
                
            </div> 
        </div>
    </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'UserClub',
    props: [
      'userData'
    ],
    data () {
      return {
        msg: 'This is User club!',
        titleName: 'Layer Data Management',
        isShowCreateLayer: false,
        isShowCreateDemoPackage: false,
        selectedLayerType: "",
        layerTypeList: [
            "3DTiles"
        ],
        allLayerStatus: {
        },
        layerInfoTemp: {
            name: undefined,
            type: undefined,
            data: undefined
        },
        demoPackageInfo: {
            name : undefined,
            dataList: []
        },
        wfcTest: ''
      }
    },
    mounted: function() {
        var that = this;
        $('.select > p').on('click', function (e) {
            $(this).parent('.select').toggleClass('open');
            e.stopPropagation();
        });
        $('.select > ul li').on('click', function (e) {
            var _this = $(this);
            $(this).parent().siblings('p').text(_this.attr('data-value'));
            that.layerInfoTemp.type = _this.attr('data-value');
            _this.addClass('selected').siblings().removeClass('selected');
            $('.select').removeClass('open');
            e.stopPropagation();
        });
    },
    methods: {
        close: function() {
            this.$emit('closeClub','');
        },
        toggleLayerStatus: function(layerName) {
            if(!this.allLayerStatus[layerName])
            {
                this.$set(this.allLayerStatus,layerName,true);
            }else{
                this.allLayerStatus[layerName] = false;
            }
        },
        cleateNewLayer: function(layerName, layerType, layerData,controlObject) {
            var that = this;
            pfAirViewer._dataSave.saveData({
                name: layerName,
                type: layerType,
                data: layerData
            }).then(function (responseData) {
                if(responseData.status === "ok")   //save ok
                {
                    responseData.data.status = "no";
                    that.userData.userInfo.layerData.unshift(responseData.data);
                    pfAirViewer._personLayerManager.addLayerData(responseData.data.name,responseData.data);
                    controlObject.controlValue = false;
                    that.isShowCreateDemoPackage = false;
                }else
                {
                    //Hints are abnormal
                }
            });
        },
        cleateDemoPackage: function() {
            this.layerInfoTemp.name = this.demoPackageInfo.name;
            this.layerInfoTemp.type = "AirPackage";
            this.layerInfoTemp.data = {
                type: this.layerInfoTemp.type,
                childs: {
                    tiles: [],
                    czmls: [],
                    flys: [],
                    view: []
                }
            };
            for(var key in this.demoPackageInfo.dataList)
            {
                var tempType = pfAirViewer._personLayerManager._layerData[ this.demoPackageInfo.dataList[key] ].type;
                if( tempType == "3dtile" )
                {
                    this.layerInfoTemp.data.childs.tiles.push(this.demoPackageInfo.dataList[key]);
                }else if( tempType == "czml" )
                {
                    this.layerInfoTemp.data.childs.czmls.push(this.demoPackageInfo.dataList[key]);
                }else if( tempType == "fly" )
                {
                    this.layerInfoTemp.data.childs.czmls.push(this.demoPackageInfo.flys[key]);
                }
            }
            this.cleateNewLayer(this.layerInfoTemp.name, this.layerInfoTemp.type, this.layerInfoTemp.data, { controlValue : this.isShowCreateDemoPackage});
        },
        switchCreateDemoPlane: function() {
            this.isShowCreateDemoPackage = !this.isShowCreateDemoPackage;
            this.demoPackageInfo.dataList = [];
            for(var key in this.allLayerStatus)
            {
                if(this.allLayerStatus[key])
                {
                    this.demoPackageInfo.dataList.push(key);
                }
            }
        },
        removeLayers: function() {
            var that = this;
            var removeLayers = [];
            for(var key in this.allLayerStatus)
            {
                if(this.allLayerStatus[key])
                {
                    removeLayers.push(key);
                }
            }
            /*this.$axios(
            {
                url : pfAirViewer._dataSave._baseUri+"/deleteLayer",
                method: 'post',
                withCredentials: true,
                data: {name: removeLayers}
            }).then(function(responseData){
                // pfAirViewer._personLayerManager.RemoveLayersData(responseData.data);
                for(var key in responseData.data.data){
                    for(var i in that.userData.userInfo.layerData)
                    {
                        if(that.userData.userInfo.layerData[i].name == responseData.data.data[key])
                        {
                            //that.userData.userInfo.layerData[i] = undefined;
                            that.userData.userInfo.layerData.splice(i, 1);
                            break;
                        }
                    }
                }
            },this.errorHandle);*/
            $.post({
                url: pfAirViewer._dataSave._baseUri+"/deleteLayer",
                xhrFields: {
                    withCredentials: true
                } ,
                data: {
                    name: removeLayers
                },
                // success: this.updateUserInfo,
                dataType: "json"
            }).done(function(responseData){
                for(var key in responseData.data){
                    for(var i in that.userData.userInfo.layerData)
                    {
                        if(that.userData.userInfo.layerData[i].name == responseData.data[key])
                        {
                            that.userData.userInfo.layerData.splice(i, 1);
                            break;
                        }
                    }
                }
                pfAirViewer._personLayerManager.removeLayersData(responseData.data);
                that.allLayerStatus = [];
            });
        },
        errorHandle: function(info){
          console.log(info);
        }
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
    margin: 0;
    padding: 0;
}
.UserClub {
    position: fixed;
    z-index: 10000;
    border-radius: 5px;
    margin: auto;
    /*top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;*/
    
    height: 86%;
    min-height: 560px;
    left: 10%;
    top: 7%;
    width: 80%;
    background: #f3f3f3 none repeat scroll 0 0;
    box-shadow: 10px 10px 30px #888888 ;
    border: medium none;
    padding: 0;
}
.title {
    background-color: #12285f;
    border: medium none;
    border-radius: 3px 3px 0 0;
    clear: both;
    color: #fff;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
}
.title strong {
    display: block;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    text-transform: uppercase;
}
.title .exit {
    background: rgba(0, 0, 0, 0) url('../../static/Cesium/Assets/AirEarth/images/close_w.png') no-repeat scroll center center;
    border: medium none;
    cursor: pointer;
    display: block;
    height: 40px;
    line-height: 40px;
    position: absolute;
    right: 0;
    text-align: center;
    text-indent: -99999px;
    top: 0;
    width: 40px;
}
.clubInfo {
    margin: 10px;
    height: 98%;
}
.tab_club_w {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
}
.tab_club_w dd a {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    border-color: #cecece #cecece -moz-use-text-color;
    border-image: none;
    border-style: solid solid none;
    border-width: 1px 1px medium;
    cursor: pointer;
    float: left;
    line-height: 29px;
    margin-right: 2px;
    padding: 0 2em;
}
.btn_t {
    border-radius: 3px 3px 0 0;
}
.btn_d {
    border-radius: 0 0 3px 3px;
}
.cf {
    overflow: hidden;
}
.cf2::after {
    clear: both;
    content: "";
    display: block;
    height: 0;
}
.tab_club_w dd .tab_light {
    background-color: #0d5881;
    border-color: #0d5881;
    color: #fff;
}
.tab_box_w {
    background: rgba(0, 0, 0, 0) url("../../static/images/icon/line.gif") repeat-y scroll 70% top;
    border: 1px solid #cecece;
    padding: 0.1em 0 0;
    height: 86%;
    min-width: 700px;
}
.l_d_btn {
    padding: 1em;
}
.box_size {
    box-sizing: border-box;
}
.l {
    float: left;
}
.r {
    float: right;
}
.l_7 {
    float: left;
    width: 70%;
}
.w_2_5 {
    padding: 1%;
    max-width: 180px;
    width: 25%;
}
.w_5 {
    width: 48%;
}
.round_s, .round_s_img img {
    border-radius: 3px;
}
.blue_btn, .blue_btn_b:hover {
    background-color: #0d5881;
}
.blue_btn:hover, .blue_btn_b {
    background-color: #12285f;
}
.red_btn {
    background-color: #bf5442;
}
.red_btn:hover {
    background-color: #ac2b15;
}
.gray_btn, .gray_btn_g:hover {
    background-color: #c5c5c5;
}
.gray_btn:hover {
    background-color: #999;
}
.gray_btn_g {
    background-color: #e0e0e0;
    color: #555;
}
.fill_btn_r {
    border: medium none;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 36px;
    text-align: center;
    vertical-align: top;
    width: 100%;
}
.blue_text, .blue_link a {
    color: #0d5881;
    cursor: pointer;
}
.data_box {
    height: 86%;
    overflow-y: auto;
}
.border_d {
    border-bottom: 1px solid #cecece;
}
.right_data_box {
    width: 30%;
    float: left;
    padding: 1em 1em 1em;
}
.gray_border {
    background: #fff none repeat scroll 0 0;
    border: 1px solid #cecece;
    margin-bottom: 1em;
}
.th_line_w {
    border-bottom: 1px solid #cecece;
    font-size: 14px;
    font-weight: normal;
    height: 40px;
    line-height: 22px;
    padding: 9px 0;
}
.o_arrow {
  background-image: url("../../static/images/icon/arrow.png");
  background-repeat: no-repeat;
  float: left;
  height: 22px;
  margin-right: 0.2em;
  margin-left: 30px;
  overflow: hidden;
  width: 22px;
}
.box_size {
    box-sizing: border-box;
}
.fill_text, .fill_textarea {
  background-color: #f3f3f3;
  border: 1px solid #e0e0e0;
  height: 32px;
  line-height: 32px;
  padding: 5px 5%;
  width: 100%;
}
.fill_text:focus, .fill_textarea:focus {
  background-color: #fff;
  border-color: #09aaf3;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
}
.r_list {
  font-size: 14px;
  margin: 0.5em 1em;
}
ul {
  list-style: outside none none;
}
input {
    color: black;
}
a {
    text-decoration: none;
}
.select {
  background-color: #f3f3f3;
  background-image: url("../../static/images/icon/option.png");
  background-position: 95% center;
  background-repeat: no-repeat;
  border: 1px solid #e0e0e0;
  height: 32px;
  position: relative;
  text-align: left;
  width: 100%;
}
.select_box {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  height: 42px;
  line-height: 42px;
  color: black;
}
.select.open ul {
  height: 150px;
  overflow-y: auto;
  top: -80px;
  transition: all 0.2s ease-in 0s;
}
.select.open ul li:nth-child(1) {
  transition: opacity 0.3s ease-in 0.05s, transform 0.3s ease-in 0.05s;
}
.select.open ul li {
  opacity: 1;
  transform: translateX(0px);
}
.select ul li {
  cursor: pointer;
  line-height: 30px;
  opacity: 0;
  padding: 0 15px;
  transform: translateX(300px);
  transition: transform 0.3s ease-out 0s;
}
.select ul li.selected {
  color: #0d5881;
}
.r_list li {
  margin: 0.6em 0;
}
.select ul {
  background-color: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  height: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 20px;
  transition: height 0.3s ease-out 0s, top 0.3s ease-out 0s;
  width: 100%;
  z-index: 1;
}
.select_box p {
  height: 42px;
  line-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}
.select p {
  cursor: pointer;
  line-height: 32px;
  padding: 0.3em 1em;
}
/*layer list*/
.line_list {
  font-size: 14px;
  margin: 1em 1em 0;
}
.line_list li {
  margin-bottom: 4px;
}
.line_list .r {
  margin: 1em 0 0 1em;
}
.line_list .t_l {
  background: #fff none repeat scroll 0 0;
  height: 40px;
  line-height: 40px;
  padding: 4px 0;
}
.line_list .active .t_l {
  border: 1px solid #aabfcb;
  padding: 3px 0;
}
.line_list li:hover .t_l {
    background-color: #0d5881;
    color: #fff;
}
.round_s_b {
  border-radius: 5px;
}
.sel_box_r input {
  display: none;
}
.sel_box_r label {
    display: inline-block;
    line-height: 16px;
}
.sel_box_r label::before {
    background-image: url("../../static/images/icon/radio.png");
    background-position: 0 0;
    background-repeat: no-repeat;
    content: "";
    display: inline-block;
    height: 16px;
    margin: 0;
    vertical-align: top;
    width: 16px;
}
.sel_box_r label {
    line-height: 20px;
}
.sel_box_r label::before {
    height: 20px;
    width: 20px;
}

.sel_box_r label::before {
    height: 20px;
    width: 20px;
}
.active .sel_box_r label::before {
    background-position: left -20px;
}
.r_cell {
  display: table-cell;
  width: 9999px;
}
.hide1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: keep-all;
}
.box_size {
  box-sizing: border-box;
}
.td_1, .td_2, .td_4, .td_3 {
  padding: 0 1%;
  width: 25%;
}
.s_arrow {
  background-image: url("../../static/images/icon/tool_arrow.png");
  background-position: -80px top;
  background-repeat: no-repeat;
  float: left;
  height: 40px;
  margin: 0 0.6em 0 0.5em;
  overflow: hidden;
  width: 40px;
}
.e_2 {
    background-position: -80px -40px;
}
.e_3 {
    background-position: -80px -80px;
}
.e_4 {
    background-position: -80px -120px;
}
.e_5 {
    background-position: -80px -160px;
}
</style>


// WEBPACK FOOTER //
// src/components/UserClub.vue